<template>
  <v-row class="pt-0" style="height: 100%;">
    <Teleport to="#settings-group-header">
      Корпорация {{ corporation_id }}
    </Teleport>  

    <Teleport to="#settings-group-actions" v-if="mini">
      <v-menu>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-for="action in actions" :key="action.title" @click="action.action()">
            <v-list-item-title>{{ action.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </Teleport>

    <Teleport to="#settings-group-actions" v-else>
      <v-container>
        <v-row>
          <v-col v-for="action in actions" :key="action.title">
            <v-btn @click="action.action" :color="action.color">
              {{ action.title }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </Teleport>

    <v-col cols="12">
      <Corporation 
        :loading="loading"
        v-model="corporation_model"
        :original_value="original_value"
        :dealers="dealers"
        @onGetList="onGetList"
        @onClickRow="editShop"
        @onAdd="addShop"
      />
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Teleport from 'vue2-teleport'
import Corporation from '../components/corporations/Corporation.vue';

export default{

  props:{
    corporation_id: [Number, String]
  },

  data: () => ({
    loading: false,
    corporation_model: {
      enabled: true,
      name: ''
    },
    original_value: {
      name: ''
    }
  }),

  computed:{
    ...mapGetters('data', ['corporation', 'dealers']),

    mini(){
      return this.$vuetify.breakpoint.smAndDown
    },

    actions(){
      return [
        { 'title': 'Удалить', 'color': "error", 'action': this.deleteCorporation },
        { 'title': `${ this.original_value.enabled ? 'Деактивировать' : 'Активировать' }`, 'color': "grey-darken", 'action': this.deactivateCorporation },
        { 'title': 'Сохранить', 'color': "primary", 'action': this.saveCorporation },
      ]
    }
  },

  methods: {
    ...mapActions('data', ['corporation_by_id', 'corporation_update', 'corporation_delete', 'corporation_deactivate']),
    ...mapActions(['throwTimeoutMessage']),

    async saveCorporation(){
      this.loading = true;
      await this.corporation_update(this.corporation_model);
      this.corporation_model = this.corporation(this.corporation_id);
      this.corporation_model = this.original_value = {...this.corporation_model};
      this.loading = false;
      this.throwTimeoutMessage({
        text: 'Успешно сохранено',
        message_class: 'success'
      })
    },

    async deleteCorporation(){
      await this.corporation_delete(this.corporation_model.id);
      this.$router.push({name: 'CorporationsList'});
      this.throwTimeoutMessage({
        text: 'Удаление завершено успешно',
        message_class: 'success'
      })
    },

    async deactivateCorporation(){
      await this.corporation_deactivate(this.original_value.id);
      this.corporation_model = this.corporation(this.corporation_id);
      this.original_value = this.corporation_model;
    },

    editShop(shop){
      if(shop.deleted)
        this.throwTimeoutMessage({
          text: "Данный ресторан удален. Доступно только чтение",
          message_class: 'warning',
        })
      else 
        this.$router.push({name: "ShopEdit", params: {shop_id: shop.id, shop: shop, corporation: {...this.original_value}}})
    },

    addShop(){
      this.$router.push({name: "ShopCreate", params: {corporation: this.original_value}})
    },

    onGetList(options){
      console.log(options)
    }
    
  },

  async mounted(){
    this.loading = true;

    let corpo = this.corporation(this.corporation_id);
    if(!corpo)
      await this.corporation_by_id(this.corporation_id);
    
    this.corporation_model = this.corporation(this.corporation_id);
    this.original_value = {...this.corporation_model};
    this.loading = false;
  },

  watch:{
    mini(val){
      console.log('now', val)
    }
  },
  
  components:{
    Teleport,
    Corporation
  }
}

</script>